export const status = {
  PENDING: 'Unassigned',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  UNDER_INVESTIGATION: 'Under Investigation',
};
